// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cinderace: PokeData = {
  "id": 815,
  "name": "cinderace",
  "height": 14,
  "weight": 330,
  "base_experience": 265,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "double-edge",
    "growl",
    "ember",
    "counter",
    "agility",
    "quick-attack",
    "bounce",
    "feint",
    "flame-charge",
    "court-change",
    "pyro-ball"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "growl",
    "ember",
    "quick-attack",
    "fire-fang",
    "eruption",
    "sunny-day",
    "morning-sun",
    "flare-blitz",
    "blaze-kick",
    "fire-punch"
  ],
  "evolution_chain": {
    "id": 431,
    "item": null,
    "species": [
      {
        "name": "scorbunny",
        "order": 813,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "raboot",
        "order": 814,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 813,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "cinderace",
        "order": 815,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 814,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 152,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
